import { render, staticRenderFns } from "./ProductMediaView.vue?vue&type=template&id=ba7b0e76&scoped=true"
import script from "./ProductMediaView.vue?vue&type=script&lang=js"
export * from "./ProductMediaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7b0e76",
  null
  
)

export default component.exports